import { Component, OnInit } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { ICredentials } from "src/app/shared/models/ICredentials";
import { catchError } from "rxjs/operators";
import { of } from "rxjs";
import { Router } from "@angular/router";
import { UsersService } from "../../admin/users/users.service";


@Component({
  selector: "app-forgot-password",
  templateUrl: "./forgot-password.component.html",
  styleUrls: ["./forgot-password.component.scss"],
})
export class ForgotPasswordComponent implements OnInit {
  resetForm: FormGroup;
  failedValidation = false;
  successReset = false;
  errorMsg: string = "Failed validation. Please try again.";

  get usernameControl() {
    return this.resetForm.controls.username;
  }
  constructor(
    private fb: FormBuilder,
    private user: UsersService,
    private router: Router
  ) {
    this.resetForm = this.fb.group({
      username: ["", Validators.required],
    });
  }
  ngOnInit() { }
  submit() {
    if (!this.resetForm.valid) {
      this.resetForm.markAllAsTouched();
      return;
    }
    const credentials: ICredentials = this.resetForm.value;
    this.user
      .resetPassword(credentials)
      .pipe(
        catchError((e) => {
          if (e.status == 400)
            this.errorMsg = e.error;
          else
            this.errorMsg = "Failed validation. Please try again.";
          return of(false);
        })
      )
      .subscribe((state) => {
        this.failedValidation = !state;
        if (state) {
          this.failedValidation = false;
          this.successReset = true;
        } else {
          this.resetForm.markAsUntouched();
        }
      });
  }
}
